import { render, staticRenderFns } from "./Periksa.vue?vue&type=template&id=37f5a9b0&"
import script from "./Periksa.vue?vue&type=script&lang=js&"
export * from "./Periksa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports